import script from "./ImportJobWorkspacePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportJobWorkspacePage.vue?vue&type=script&setup=true&lang=js"

import "./ImportJobWorkspacePage.vue?vue&type=style&index=0&id=322ad34f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322ad34f"]])

export default __exports__